import React from 'react';
import './App.css';
import ProjectNavbar from "./components/ProjectNavbar";
import Comments from './components/Comments';
import SailImage from './components/SailImageV2';
import CurveInfo from './Curves/CurveInfo';
import Grid from '@material-ui/core/Grid';

const axios = require('axios');



class TrueNorthSASail extends React.Component {
    constructor(props) {
        super(props);

        //let u = this.getUrlVars();

        this.state = {
            name: '',
            url: '',  
            ratio: 1,
            updated: false,
            curves: [],
            selectedCurve: null,
            selectedLine: null,
            lines: [],
            centreline: false,
            centrelineTwist: 0,
            points: [],
            Xmin: 0,
            Ymin: 0,
            pointer: 'default',
            imageInfo: null,
            imageTime: false,
            imageSRC: '',
            image:null,
            project: false,
            projectDir: false,
            projectName: '',
            saildialog: false,
            sail: '',
            sailType: '',
            isImage: false,
            Log: '',
            LogData: [],
            comments:"",   
          }; 

    }

componentDidMount() {
    this.getUrlVars();
}

getUrlVars =() => {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    let x = "https://www.dropbox.com" + vars.x;
    this.readSails(x);
    return x;
}

fetchURLfile = (uRl, callback) =>{
    const PROXY_URL = 'https://cors-anywhere.herokuapp.com/';
    const myURL = (uRl);
    const newURL = myURL.replace('dl=0', "raw=1")
    axios.get(PROXY_URL + newURL)
    .then(response=> {
       callback(response.data);
    })
    .catch(function (error) {
      let data = false;
      callback(data);
      alert(error);
    })
    .finally(function () {

    });
  }

 readSails = (uRl) =>{

    const self = this;
    
    this.fetchURLfile(uRl,(value) =>{  

        const myURL = (value.imagePath);
        const newURL = myURL.replace('dl=0', "raw=1");
        this.myImage.openSail(newURL, value)

    });
}

render() {

    const {url} = this.state;
    let curveInfo = [];
    const {imageInfo} = this.state;
    
    if(this.state.curves.length > 0){
      let crvs = [...this.state.curves];
      crvs.sort((a, b) => (a.name > b.name) ? 1 : -1)
      curveInfo = (<CurveInfo data={crvs} editHandler={this.editCurve}></CurveInfo>);
    }


    let img = (        
        <SailImage ref={node => {this.myImage = node;}}  app={this} />
        );

    let imgInfo;
    let logInfo;
    let comments;

    /*
    if(this.state.isImage){
      imgInfo = (
        <ImageData ref={node => {this.imageDataRef = node;}}  data={imageInfo} sail={this.state.sail} app={this}></ImageData>
      );

      logInfo = (
        <LogData ref={node=>{this.loginforef = node;}} app={this} data={imageInfo}></LogData>
      );
*/
      comments = (
        <Comments ref={node=>{this.commentsref = node;}} app={this}></Comments>
      );
   // }

    return (
        <div style={{height:'100%'}}>
          <ProjectNavbar parent={this}></ProjectNavbar>  
         
        <Grid 
            container>   

            <Grid item xs={12} sm={12} md={12} lg={8} style={{margin:'0px 10px'}}  ref={this.imageGrid}>
              {img}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={4} style={{margin:'0px 10px'}}>
                {comments}
            </Grid>

          </Grid>   
          </div>  
        );
    }
}
    
export default TrueNorthSASail;